import { BananaSpine } from "./../room/banana/BananaSpine";
import { GameConstants } from "./../../GameConstants";
import { GameVars } from "../../GameVars";
import { Background } from "../background/Background";
import { Button } from "../../utils/Button";
import { GameManager } from "../../managers/GameManager";

export class BananaScene extends Phaser.Scene {

    public static currentInstance: BananaScene;

    private banana: BananaSpine;

    constructor() {

        super("BananaScene");

        BananaScene.currentInstance = this;
    
    }

    public create(): void {

        GameVars.currentScene = this;

        const background = new Background(this);
        this.add.existing(background);

        if (GameConstants.ANIMATION_SCENES) {
            const backButton = new Button(this, 35 * GameVars.scaleX, 35, "texture_atlas_1", "btn_back.png", "btn_back.png", true, true);
            backButton.scaleX = GameVars.scaleX;
            backButton.onUp(this.onClickBack, this);
            this.add.existing(backButton);
        }

        this.banana = new BananaSpine(this);
        this.banana.x = GameConstants.GAME_WIDTH / 2 - 100;
        this.banana.y = 30;
        this.add.existing(this.banana);

        let offX = 55;
        let offY = -140;

        let button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton1Down, this);
        this.add.existing(button);

        let text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, "BLINK", {fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000"});
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120; 

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton2Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, "ELIMINACION", {fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000"});
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120; 

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton3Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, "FOLD", {fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000"});
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120; 

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton4Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, "NEUTRAL", {fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000"});
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton5Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, "RISE 1", {fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000"});
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton6Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, "RISE 2", {fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000"});
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton7Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, "RISE 3", {fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000"});
        text.setOrigin(.5);
        this.add.existing(text);

        offX = 55;
        offY += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton8Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, "TALK INTRO", {fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000"});
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton9Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, "VICTORY 1", {fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000"});
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton10Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, "VICTORY 2", {fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000"});
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton11Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, "VICTORY 3", {fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000"});
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton12Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, "VICTORY BLUFF", {fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000"});
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton13Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, "YOU LOSE START", {fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000"});
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton14Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, "YOU LOSE BUCLE", {fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000"});
        text.setOrigin(.5);
        this.add.existing(text);
    }

    private onButton1Down(): void {

        this.banana.setAvatarAnimation("blink");
    }

    private onButton2Down(): void {

        this.banana.setAvatarState("eliminacion");
    }

    private onButton3Down(): void {

        this.banana.setAvatarState("fold");
    }

    private onButton4Down(): void {

        this.banana.setAvatarState("neutral");
    }

    private onButton5Down(): void {

        this.banana.setAvatarState("rise1");
    }

    private onButton6Down(): void {

        this.banana.setAvatarState("rise2");
    }

    private onButton7Down(): void {

        this.banana.setAvatarState("rise3");
    }

    private onButton8Down(): void {

        this.banana.setAvatarState("talk-intro");
    }

    private onButton9Down(): void {

        this.banana.setAvatarState("victory1");
    }

    private onButton10Down(): void {

        this.banana.setAvatarState("victory2");
    }

    private onButton11Down(): void {

        this.banana.setAvatarState("victory3");
    }

    private onButton12Down(): void {

        this.banana.setAvatarState("victory-bluff");
    }

    private onButton13Down(): void {

        this.banana.setAvatarState("you-lose-start");
    }

    private onButton14Down(): void {

        this.banana.setAvatarState("you-lose_bucle");
    }

    private onClickBack(): void {

        GameManager.enterRoomScene();
    }
}
